import { useState } from "react";
import { login } from "../../api/auth";
import eyeOn from "../../images/icons/eye_on.svg";
import eyeOff from "../../images/icons/eye_off.svg";

const Login = ({ onLoginSuccess }) => {
  const [data, setData] = useState({
    login: "",
    password: "",
  });

  const [errorMessage, setErrorMessage] = useState({
    field: null,
    message: null,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage({ field: null, message: null });
    setIsLoading(true);

    try {
      const response = await login(data.login, data.password);

      if (onLoginSuccess) {
        onLoginSuccess(response);
      }
    } catch (error) {
      console.error("Login error: ", error);

      if (error?.message) {
        setErrorMessage({
          field: "common",
          message: error.message,
        });
      } else {
        setErrorMessage({
          field: "common",
          message: "Произошла непредвиденная ошибка, попробуйте снова",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field) => (e) => {
    setData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleResetPassword = () => {};

  return (
    <form
      className="login-window form flex-column gap-5x"
      onSubmit={(e) => handleLogin(e)}
    >
      <h2>Авторизация</h2>

      <label className="flex-column column-start gap-1x w-100">
        <span className="text-s label-text">Логин</span>
        <input
          type="text"
          autoComplete="off"
          required={true}
          value={data.login}
          onChange={handleInputChange("login")}
          className={`text-m w-100
            ${errorMessage.field === "login" ? "input-error" : ""} 
          `}
        />
        {errorMessage.field === "login" && (
          <span className="error-message">{errorMessage.message}</span>
        )}
      </label>

      <label className="flex-column column-start gap-1x w-100">
        <span className="text-s label-text">Пароль</span>
        <div className="password-wrapper flex-row w-100">
          <input
            type={showPassword ? "text" : "password"}
            autoComplete="off"
            required
            value={data.password}
            onChange={handleInputChange("password")}
            className={`text-m w-100 ${
              errorMessage.field === "password" ? "input-error" : ""
            }`}
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? (
              <img src={eyeOff} alt="hide password" />
            ) : (
              <img src={eyeOn} alt="show password" />
            )}
          </button>
        </div>
        {errorMessage.field === "password" && (
          <span className="error-message">{errorMessage.message}</span>
        )}
      </label>

      {errorMessage.field === "common" && (
        <span className="error-message">{errorMessage.message}</span>
      )}

      <button
        type="submit"
        className="btn-primary size-m border-radius-s text-m w-100"
        disabled={isLoading}
      >
        {isLoading ? "Вход..." : "Войти"}
      </button>
    </form>
  );
};

export default Login;